import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CustomizedTypography } from '@components/Customized';
import { CapaQuotationServiceType } from '@generated/graphql';
import * as assets from '@assets';
import FormInputLayout from '../Layout/FormInputLayout';
import RequestFormFileInput from './RequestFormFileInput';

const CircuitAssemblyFileInput: React.FC<{
  filesRef?: React.MutableRefObject<any[]>;
}> = ({ filesRef }) => {
  const { errors } = useFormContext();

  return (
    <FormInputLayout
      label="BOM파일 등록"
      required={true}
      description="(csv, xls, xlsx, 최대 용량 5M)"
    >
      <RequestFormFileInput
        serviceType={CapaQuotationServiceType.Pcb}
        filesRef={filesRef}
        quantityLimit={10}
        sizeLimitMB={5}
        type="BOM"
        acceptFileFormats=".csv, .xls, .xlsx"
        error={errors?.pcb?.['assembleFiles']?.message}
        icon={
          <img
            src={assets.PCBAssembleFileInputIcon}
            width={37}
            height={56}
            alt="BOM파일 업로드"
          />
        }
        title={
          <CustomizedTypography
            variant="subtitle1"
            fontWeight="500"
            color="textPrimary"
            gutterBottoms={30}
            align="center"
          >
            조립을 위한 BOM파일을 <br />
            끌어다 놓으세요.
          </CustomizedTypography>
        }
        onDragText={
          <CustomizedTypography
            variant={'h4'}
            fontWeight="500"
            color="textPrimary"
            align="center"
          >
            끌어다 놓으세요.
          </CustomizedTypography>
        }
        description={<></>}
      />
    </FormInputLayout>
  );
};

export default React.memo(CircuitAssemblyFileInput);
